import { PlusOutlined, DownOutlined as _DownOutlined, CloseOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { useAppSelector, useAppDispatch } from '@/hooks'
import { setGlobalTags } from '@/features/SetSixLawsInfo/setSixLawsInfo'
import { Select } from 'antd'
interface TagTreeI {
  value: string
  label: string
}

const Qiyun = () => {
  const dispatch = useAppDispatch()
  //根据当前选中的局部标签确定被选中的框的areaId
  const globalTags = useAppSelector((state) => state.sixLawsInfo.globalTags)
  const globalTagTree = useAppSelector((state) => state.sixLawsInfo.globalTagTree)
  const [yijingTrees, setYijingTrees] = useState<TagTreeI[]>([])
  const [inputTags, setInputTags] = useState<string>('')

  useEffect(() => {
    const newYijingTrees: TagTreeI[] = []
    for (let i = 0; i < globalTagTree.意境.length; i++) {
      newYijingTrees.push({
        value: globalTagTree.意境[i],
        label: globalTagTree.意境[i]
      })
    }
    setYijingTrees(newYijingTrees)
  }, [globalTagTree])

  return (
    <div className='qiyun-panel'>
      <div className='qiyun-title'>
        <h2>气韵生动</h2>
        <div className='addNewTag'>
          <Select
            value={'意境'}
            options={yijingTrees}
            onChange={(value) => {
              if (!globalTags.意境.includes(value)) {
                const newCurrentTags = [...globalTags.意境, value]
                const newGlobalTags = JSON.parse(JSON.stringify(globalTags))
                newGlobalTags.意境 = newCurrentTags
                dispatch(setGlobalTags(newGlobalTags))
              }
            }}
          />
          <div className='addNewTag-divider'></div>
          <input
            className='addNewTag-input'
            value={inputTags}
            onChange={(e) => {
              setInputTags(e.target.value)
            }}
          ></input>
          <div
            className='addNewTag-addButton'
            onClick={() => {
              if (inputTags !== '' && !globalTags.意境.includes(inputTags)) {
                const newCurrentTags = [...globalTags.意境, inputTags]
                const newGlobalTags = JSON.parse(JSON.stringify(globalTags))
                newGlobalTags.意境 = newCurrentTags
                dispatch(setGlobalTags(newGlobalTags))
                setInputTags('')
              }
            }}
          >
            <PlusOutlined style={{ color: 'white' }} />
          </div>
        </div>
      </div>
      <div className='qiyun-tags'>
        {globalTags.意境.map((item) => {
          return (
            <div className='editableTag' key={item}>
              <div className='editableTag-title'>{item}</div>
              <button
                className='editableTag-delete'
                onClick={() => {
                  const newCurrentTags = globalTags.意境.filter((i) => i !== item)
                  const newGlobalTags = JSON.parse(JSON.stringify(globalTags))
                  newGlobalTags.意境 = newCurrentTags
                  dispatch(setGlobalTags(newGlobalTags))
                }}
              >
                <CloseOutlined className='editableTag-cross' />
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Qiyun
